import { render } from "./FundHistoryTransfer.vue?vue&type=template&id=77ba04d7&scoped=true"
import script from "./FundHistoryTransfer.vue?vue&type=script&lang=js"
export * from "./FundHistoryTransfer.vue?vue&type=script&lang=js"

import "./FundHistoryTransfer.vue?vue&type=style&index=0&id=77ba04d7&lang=less&scoped=true"
import "./FundHistoryTransfer.vue?vue&type=style&index=1&id=77ba04d7&lang=less"

import exportComponent from "/home/data/jenkins/workspace/Pro_TWI_T/Pro_TWI_h5_advantrade-website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77ba04d7"]])

export default __exports__